import React, { useState } from "react";
import {Icon} from '../Components/UI/Icon'
import PricingCard from '../Components/PricingCard'


export default function TestPage({ children }) {



  return (
    <PricingCard
      IconSvg={<Icon name={'youtube'}/>}
      popular={true}
      title={'Basic'}
      subtitle={'For teams making an early commitment to demonstrating trust'}
      price={'40'}
      billingCycleLabel={'month billed annualy'}
      features={['tutto','tutto','tutto','tutto','tutto','tutto','tutto',]}
    />
  );
};

